///No.Of.doors
const GET_CATALOG_UPDATE_NO_OF_DOORS = 'GET_CATALOG_UPDATE_NO_OF_DOORS';
const SET_CATALOG_UPDATE_NO_OF_DOORS = 'SET_CATALOG_UPDATE_NO_OF_DOORS';

const GET_CATALOG_UPDATE_NO_OF_DOORS_SAVE = 'GET_CATALOG_UPDATE_NO_OF_DOORS_SAVE';
const SET_CATALOG_UPDATE_NO_OF_DOORS_SAVE = 'SET_CATALOG_UPDATE_NO_OF_DOORS_SAVE';

const GET_CATALOG_UPDATE_NO_OF_DOORS_VALIDATE = 'GET_CATALOG_UPDATE_NO_OF_DOORS_VALIDATE';
const SET_CATALOG_UPDATE_NO_OF_DOORS_VALIDATE = 'SET_CATALOG_UPDATE_NO_OF_DOORS_VALIDATE';

const GET_CATALOG_REMOVE_NO_OF_DOORS = 'GET_CATALOG_REMOVE_NO_OF_DOORS';
const SET_CATALOG_REMOVE_NO_OF_DOORS = 'SET_CATALOG_REMOVE_NO_OF_DOORS';

///Year
const GET_CATALOG_UPDATE_YEAR = 'GET_CATALOG_UPDATE_YEAR';
const SET_CATALOG_UPDATE_YEAR = 'SET_CATALOG_UPDATE_YEAR';

const GET_CATALOG_UPDATE_YEAR_SAVE = 'GET_CATALOG_UPDATE_YEAR_SAVE';
const SET_CATALOG_UPDATE_YEAR_SAVE = 'SET_CATALOG_UPDATE_YEAR_SAVE';

const GET_CATALOG_UPDATE_YEAR_VALIDATE = 'GET_CATALOG_UPDATE_YEAR_VALIDATE';
const SET_CATALOG_UPDATE_YEAR_VALIDATE = 'SET_CATALOG_UPDATE_YEAR_VALIDATE';

const GET_CATALOG_REMOVE_YEAR = 'GET_CATALOG_REMOVE_YEAR';
const SET_CATALOG_REMOVE_YEAR = 'SET_CATALOG_REMOVE_YEAR';

///Capacity
const GET_CATALOG_UPDATE_CAPACITY = 'GET_CATALOG_UPDATE_CAPACITY';
const SET_CATALOG_UPDATE_CAPACITY = 'SET_CATALOG_UPDATE_CAPACITY';

const GET_CATALOG_UPDATE_CAPACITY_SAVE = 'GET_CATALOG_UPDATE_CAPACITY_SAVE';
const SET_CATALOG_UPDATE_CAPACITY_SAVE = 'SET_CATALOG_UPDATE_CAPACITY_SAVE';

const GET_CATALOG_UPDATE_CAPACITY_VALIDATE = 'GET_CATALOG_UPDATE_CAPACITY_VALIDATE';
const SET_CATALOG_UPDATE_CAPACITY_VALIDATE = 'SET_CATALOG_UPDATE_CAPACITY_VALIDATE';

const GET_CATALOG_REMOVE_CAPACITY = 'GET_CATALOG_REMOVE_CAPACITY';
const SET_CATALOG_REMOVE_CAPACITY = 'SET_CATALOG_REMOVE_CAPACITY';

///Upfit
const GET_CATALOG_UPDATE_UPFIT = 'GET_CATALOG_UPDATE_UPFIT';
const SET_CATALOG_UPDATE_UPFIT = 'SET_CATALOG_UPDATE_UPFIT';

const GET_CATALOG_UPDATE_UPFIT_SAVE = 'GET_CATALOG_UPDATE_UPFIT_SAVE';
const SET_CATALOG_UPDATE_UPFIT_SAVE = 'SET_CATALOG_UPDATE_UPFIT_SAVE';

const GET_CATALOG_UPDATE_UPFIT_VALIDATE = 'GET_CATALOG_UPDATE_UPFIT_VALIDATE';
const SET_CATALOG_UPDATE_UPFIT_VALIDATE = 'SET_CATALOG_UPDATE_UPFIT_VALIDATE';

const GET_CATALOG_REMOVE_UPFIT = 'GET_CATALOG_REMOVE_UPFIT';
const SET_CATALOG_REMOVE_UPFIT = 'SET_CATALOG_REMOVE_UPFIT';

///Drive Train
const GET_CATALOG_UPDATE_DRIVE_TRAIN = 'GET_CATALOG_UPDATE_DRIVE_TRAIN';
const SET_CATALOG_UPDATE_DRIVE_TRAIN = 'SET_CATALOG_UPDATE_DRIVE_TRAIN';

const GET_CATALOG_UPDATE_DRIVE_TRAIN_SAVE = 'GET_CATALOG_UPDATE_DRIVE_TRAIN_SAVE';
const SET_CATALOG_UPDATE_DRIVE_TRAIN_SAVE = 'SET_CATALOG_UPDATE_DRIVE_TRAIN_SAVE';

const GET_CATALOG_UPDATE_DRIVE_TRAIN_VALIDATE = 'GET_CATALOG_UPDATE_DRIVE_TRAIN_VALIDATE';
const SET_CATALOG_UPDATE_DRIVE_TRAIN_VALIDATE = 'SET_CATALOG_UPDATE_DRIVE_TRAIN_VALIDATE';

const GET_CATALOG_REMOVE_DRIVE_TRAIN = 'GET_CATALOG_REMOVE_DRIVE_TRAIN';
const SET_CATALOG_REMOVE_DRIVE_TRAIN = 'SET_CATALOG_REMOVE_DRIVE_TRAIN';

///Power Type
const GET_CATALOG_UPDATE_POWER_TYPE = 'GET_CATALOG_UPDATE_POWER_TYPE';
const SET_CATALOG_UPDATE_POWER_TYPE = 'SET_CATALOG_UPDATE_POWER_TYPE';

const GET_CATALOG_UPDATE_POWER_TYPE_SAVE = 'GET_CATALOG_UPDATE_POWER_TYPE_SAVE';
const SET_CATALOG_UPDATE_POWER_TYPE_SAVE = 'SET_CATALOG_UPDATE_POWER_TYPE_SAVE';

const GET_CATALOG_UPDATE_POWER_TYPE_VALIDATE = 'GET_CATALOG_UPDATE_POWER_TYPE_VALIDATE';
const SET_CATALOG_UPDATE_POWER_TYPE_VALIDATE = 'SET_CATALOG_UPDATE_POWER_TYPE_VALIDATE';

const GET_CATALOG_REMOVE_POWER_TYPE = 'GET_CATALOG_REMOVE_POWER_TYPE';
const SET_CATALOG_REMOVE_POWER_TYPE = 'SET_CATALOG_REMOVE_POWER_TYPE';

///Vehicle Level
const GET_CATALOG_UPDATE_VEHICLE_LEVEL = 'GET_CATALOG_UPDATE_VEHICLE_LEVEL';
const SET_CATALOG_UPDATE_VEHICLE_LEVEL = 'SET_CATALOG_UPDATE_VEHICLE_LEVEL';

const GET_CATALOG_UPDATE_VEHICLE_LEVEL_SAVE = 'GET_CATALOG_UPDATE_VEHICLE_LEVEL_SAVE';
const SET_CATALOG_UPDATE_VEHICLE_LEVEL_SAVE = 'SET_CATALOG_UPDATE_VEHICLE_LEVEL_SAVE';

const GET_CATALOG_UPDATE_VEHICLE_LEVEL_VALIDATE = 'GET_CATALOG_UPDATE_VEHICLE_LEVEL_VALIDATE';
const SET_CATALOG_UPDATE_VEHICLE_LEVEL_VALIDATE = 'SET_CATALOG_UPDATE_VEHICLE_LEVEL_VALIDATE';

const GET_CATALOG_REMOVE_VEHICLE_LEVEL = 'GET_CATALOG_REMOVE_VEHICLE_LEVEL';
const SET_CATALOG_REMOVE_VEHICLE_LEVEL = 'SET_CATALOG_REMOVE_VEHICLE_LEVEL';

///EQ Class Code
const GET_CATALOG_UPDATE_EQ_CLASS_CODE = 'GET_CATALOG_UPDATE_EQ_CLASS_CODE';
const SET_CATALOG_UPDATE_EQ_CLASS_CODE = 'SET_CATALOG_UPDATE_EQ_CLASS_CODE';

const GET_CATALOG_UPDATE_EQ_CLASS_CODE_SAVE = 'GET_CATALOG_UPDATE_EQ_CLASS_CODE_SAVE';
const SET_CATALOG_UPDATE_EQ_CLASS_CODE_SAVE = 'SET_CATALOG_UPDATE_EQ_CLASS_CODE_SAVE';

const GET_CATALOG_UPDATE_EQ_CLASS_CODE_VALIDATE = 'GET_CATALOG_UPDATE_EQ_CLASS_CODE_VALIDATE';
const SET_CATALOG_UPDATE_EQ_CLASS_CODE_VALIDATE = 'SET_CATALOG_UPDATE_EQ_CLASS_CODE_VALIDATE';

const GET_CATALOG_REMOVE_EQ_CLASS_CODE = 'GET_CATALOG_REMOVE_EQ_CLASS_CODE';
const SET_CATALOG_REMOVE_EQ_CLASS_CODE = 'SET_CATALOG_REMOVE_EQ_CLASS_CODE';

///Make
const GET_CATALOG_UPDATE_MAKE = 'GET_CATALOG_UPDATE_MAKE';
const SET_CATALOG_UPDATE_MAKE = 'SET_CATALOG_UPDATE_MAKE';

const GET_CATALOG_UPDATE_MAKE_SAVE = 'GET_CATALOG_UPDATE_MAKE_SAVE';
const SET_CATALOG_UPDATE_MAKE_SAVE = 'SET_CATALOG_UPDATE_MAKE_SAVE';

const GET_CATALOG_UPDATE_MAKE_VALIDATE = 'GET_CATALOG_UPDATE_MAKE_VALIDATE';
const SET_CATALOG_UPDATE_MAKE_VALIDATE = 'SET_CATALOG_UPDATE_MAKE_VALIDATE';

const GET_CATALOG_REMOVE_MAKE = 'GET_CATALOG_REMOVE_MAKE';
const SET_CATALOG_REMOVE_MAKE = 'SET_CATALOG_REMOVE_MAKE';

///State Availability
const GET_CATALOG_UPDATE_STATE_AVAILABILITY = 'GET_CATALOG_UPDATE_STATE_AVAILABILITY';
const SET_CATALOG_UPDATE_STATE_AVAILABILITY = 'SET_CATALOG_UPDATE_STATE_AVAILABILITY';

const GET_CATALOG_UPDATE_STATE_AVAILABILITY_SAVE = 'GET_CATALOG_UPDATE_STATE_AVAILABILITY_SAVE';
const SET_CATALOG_UPDATE_STATE_AVAILABILITY_SAVE = 'SET_CATALOG_UPDATE_STATE_AVAILABILITY_SAVE';

const GET_CATALOG_UPDATE_STATE_AVAILABILITY_VALIDATE = 'GET_CATALOG_UPDATE_STATE_AVAILABILITY_VALIDATE';
const SET_CATALOG_UPDATE_STATE_AVAILABILITY_VALIDATE = 'SET_CATALOG_UPDATE_STATE_AVAILABILITY_VALIDATE';

const GET_CATALOG_REMOVE_STATE_AVAILABILITY = 'GET_CATALOG_REMOVE_STATE_AVAILABILITY';
const SET_CATALOG_REMOVE_STATE_AVAILABILITY = 'SET_CATALOG_REMOVE_STATE_AVAILABILITY';

///Model
const GET_CATALOG_UPDATE_MODEL_SAVE = 'GET_CATALOG_UPDATE_MODEL_SAVE';
const SET_CATALOG_UPDATE_MODEL_SAVE = 'SET_CATALOG_UPDATE_MODEL_SAVE';

const GET_CATALOG_UPDATE_MODEL_VALIDATE = 'GET_CATALOG_UPDATE_MODEL_VALIDATE';
const SET_CATALOG_UPDATE_MODEL_VALIDATE = 'SET_CATALOG_UPDATE_MODEL_VALIDATE';

const GET_CATALOG_UPDATE_MODEL = 'GET_CATALOG_UPDATE_MODEL';
const SET_CATALOG_UPDATE_MODEL = 'SET_CATALOG_UPDATE_MODEL';

const GET_CATALOG_REMOVE_MODEL = 'GET_CATALOG_REMOVE_MODEL';
const SET_CATALOG_REMOVE_MODEL = 'SET_CATALOG_REMOVE_MODEL';

//Budgeting Percent
const GET_BUDGETING_PERCENT_LIST = "GET_BUDGETING_PERCENT_LIST"
const SET_BUDGETING_PERCENT_LIST = "SET_BUDGETING_PERCENT_LIST"

const SAVE_BUDGETING_PERCENT_OPTION = "SAVE_BUDGETING_PERCENT_OPTION"
const IS_BUDGETING_PERCENT_OPTION_SAVED = "IS_BUDGETING_PERCENT_OPTION_SAVED"

const VALIDATE_BUDGETING_PERCENT_OPTION = "VALIDATE_BUDGETING_PERCENT_OPTION"
const IS_BUDGETING_PERCENT_OPTION_VALID = "IS_BUDGETING_PERCENT_OPTION_VALID"

const DELETE_BUDGETING_PERCENT_OPTION = "DELETE_BUDGETING_PERCENT_OPTION"
const IS_BUDGETING_PERCENT_OPTION_DELETED = "IS_BUDGETING_PERCENT_OPTION_DELETED"

//Useful Life / Lease Terms
const GET_USEFUL_LIFE_LIST = "GET_USEFUL_LIFE_LIST"
const SET_USEFUL_LIFE_LIST = "SET_USEFUL_LIFE_LIST"

const SAVE_USEFUL_LIFE_OPTION = "SAVE_USEFUL_LIFE_OPTION"
const IS_USEFUL_LIFE_OPTION_SAVED = "IS_USEFUL_LIFE_OPTION_SAVED"

const VALIDATE_USEFUL_LIFE_OPTION = "VALIDATE_USEFUL_LIFE_OPTION"
const IS_USEFUL_LIFE_OPTION_VALID = "IS_USEFUL_LIFE_OPTION_VALID"

const DELETE_USEFUL_LIFE_OPTION = "DELETE_USEFUL_LIFE_OPTION"
const IS_USEFUL_LIFE_OPTION_DELETED = "IS_USEFUL_LIFE_OPTION_DELETED"

///Program status
const GET_CATALOG_UPDATE_PROGRAM_STATUS = 'GET_CATALOG_UPDATE_PROGRAM_STATUS';
const SET_CATALOG_UPDATE_PROGRAM_STATUS = 'SET_CATALOG_UPDATE_PROGRAM_STATUS';

const GET_CATALOG_UPDATE_PROGRAM_STATUS_SAVE = 'GET_CATALOG_UPDATE_PROGRAM_STATUS_SAVE';
const SET_CATALOG_UPDATE_PROGRAM_STATUS_SAVE = 'SET_CATALOG_UPDATE_PROGRAM_STATUS_SAVE';

const GET_CATALOG_UPDATE_PROGRAM_STATUS_VALIDATE = 'GET_CATALOG_UPDATE_PROGRAM_STATUS_VALIDATE';
const SET_CATALOG_UPDATE_PROGRAM_STATUS_VALIDATE = 'SET_CATALOG_UPDATE_PROGRAM_STATUS_VALIDATE';

const GET_CATALOG_REMOVE_PROGRAM_STATUS = 'GET_CATALOG_REMOVE_PROGRAM_STATUS';
const SET_CATALOG_REMOVE_PROGRAM_STATUS = 'SET_CATALOG_REMOVE_PROGRAM_STATUS';

///Annual Hours
const GET_CATALOG_UPDATE_ANNUAL_HOURS = 'GET_CATALOG_UPDATE_ANNUAL_HOURS';
const SET_CATALOG_UPDATE_ANNUAL_HOURS = 'SET_CATALOG_UPDATE_ANNUAL_HOURS';

const GET_CATALOG_UPDATE_ANNUAL_HOURS_SAVE = 'GET_CATALOG_UPDATE_ANNUAL_HOURS_SAVE';
const SET_CATALOG_UPDATE_ANNUAL_HOURS_SAVE = 'SET_CATALOG_UPDATE_ANNUAL_HOURS_SAVE';

const GET_CATALOG_UPDATE_ANNUAL_HOURS_VALIDATE = 'GET_CATALOG_UPDATE_ANNUAL_HOURS_VALIDATE';
const SET_CATALOG_UPDATE_ANNUAL_HOURS_VALIDATE = 'SET_CATALOG_UPDATE_ANNUAL_HOURS_VALIDATE';

const GET_CATALOG_REMOVE_ANNUAL_HOURS = 'GET_CATALOG_REMOVE_ANNUAL_HOURS';
const SET_CATALOG_REMOVE_ANNUAL_HOURS = 'SET_CATALOG_REMOVE_ANNUAL_HOURS';

///Deck size
const GET_CATALOG_UPDATE_DECK_SIZE = 'GET_CATALOG_UPDATE_DECK_SIZE';
const SET_CATALOG_UPDATE_DECK_SIZE = 'SET_CATALOG_UPDATE_DECK_SIZE';

const GET_CATALOG_UPDATE_DECK_SIZE_SAVE = 'GET_CATALOG_UPDATE_DECK_SIZE_SAVE';
const SET_CATALOG_UPDATE_DECK_SIZE_SAVE = 'SET_CATALOG_UPDATE_DECK_SIZE_SAVE';

const GET_CATALOG_UPDATE_DECK_SIZE_VALIDATE = 'GET_CATALOG_UPDATE_DECK_SIZE_VALIDATE';
const SET_CATALOG_UPDATE_DECK_SIZE_VALIDATE = 'SET_CATALOG_UPDATE_DECK_SIZE_VALIDATE';

const GET_CATALOG_REMOVE_DECK_SIZE = 'GET_CATALOG_REMOVE_DECK_SIZE';
const SET_CATALOG_REMOVE_DECK_SIZE = 'SET_CATALOG_REMOVE_DECK_SIZE';

///Deck type
const GET_CATALOG_UPDATE_DECK_TYPE = 'GET_CATALOG_UPDATE_DECK_TYPE';
const SET_CATALOG_UPDATE_DECK_TYPE = 'SET_CATALOG_UPDATE_DECK_TYPE';

const GET_CATALOG_UPDATE_DECK_TYPE_SAVE = 'GET_CATALOG_UPDATE_DECK_TYPE_SAVE';
const SET_CATALOG_UPDATE_DECK_TYPE_SAVE = 'SET_CATALOG_UPDATE_DECK_TYPE_SAVE';

const GET_CATALOG_UPDATE_DECK_TYPE_VALIDATE = 'GET_CATALOG_UPDATE_DECK_TYPE_VALIDATE';
const SET_CATALOG_UPDATE_DECK_TYPE_VALIDATE = 'SET_CATALOG_UPDATE_DECK_TYPE_VALIDATE';

const GET_CATALOG_REMOVE_DECK_TYPE = 'GET_CATALOG_REMOVE_DECK_TYPE';
const SET_CATALOG_REMOVE_DECK_TYPE = 'SET_CATALOG_REMOVE_DECK_TYPE';

///Length
const GET_CATALOG_UPDATE_LENGTH = 'GET_CATALOG_UPDATE_LENGTH';
const SET_CATALOG_UPDATE_LENGTH = 'SET_CATALOG_UPDATE_LENGTH';

const GET_CATALOG_UPDATE_LENGTH_SAVE = 'GET_CATALOG_UPDATE_LENGTH_SAVE';
const SET_CATALOG_UPDATE_LENGTH_SAVE = 'SET_CATALOG_UPDATE_LENGTH_SAVE';

const GET_CATALOG_UPDATE_LENGTH_VALIDATE = 'GET_CATALOG_UPDATE_LENGTH_VALIDATE';
const SET_CATALOG_UPDATE_LENGTH_VALIDATE = 'SET_CATALOG_UPDATE_LENGTH_VALIDATE';

const GET_CATALOG_REMOVE_LENGTH = 'GET_CATALOG_REMOVE_LENGTH';
const SET_CATALOG_REMOVE_LENGTH = 'SET_CATALOG_REMOVE_LENGTH';

///Size
const GET_CATALOG_UPDATE_SIZE = 'GET_CATALOG_UPDATE_SIZE';
const SET_CATALOG_UPDATE_SIZE = 'SET_CATALOG_UPDATE_SIZE';

const GET_CATALOG_UPDATE_SIZE_SAVE = 'GET_CATALOG_UPDATE_SIZE_SAVE';
const SET_CATALOG_UPDATE_SIZE_SAVE = 'SET_CATALOG_UPDATE_SIZE_SAVE';

const GET_CATALOG_UPDATE_SIZE_VALIDATE = 'GET_CATALOG_UPDATE_SIZE_VALIDATE';
const SET_CATALOG_UPDATE_SIZE_VALIDATE = 'SET_CATALOG_UPDATE_SIZE_VALIDATE';

const GET_CATALOG_REMOVE_SIZE = 'GET_CATALOG_REMOVE_SIZE';
const SET_CATALOG_REMOVE_SIZE = 'SET_CATALOG_REMOVE_SIZE';

///Autonomous
const GET_CATALOG_UPDATE_AUTONOMOUS = 'GET_CATALOG_UPDATE_AUTONOMOUS';
const SET_CATALOG_UPDATE_AUTONOMOUS = 'SET_CATALOG_UPDATE_AUTONOMOUS';

const GET_CATALOG_UPDATE_AUTONOMOUS_SAVE = 'GET_CATALOG_UPDATE_AUTONOMOUS_SAVE';
const SET_CATALOG_UPDATE_AUTONOMOUS_SAVE = 'SET_CATALOG_UPDATE_AUTONOMOUS_SAVE';

const GET_CATALOG_UPDATE_AUTONOMOUS_VALIDATE = 'GET_CATALOG_UPDATE_AUTONOMOUS_VALIDATE';
const SET_CATALOG_UPDATE_AUTONOMOUS_VALIDATE = 'SET_CATALOG_UPDATE_AUTONOMOUS_VALIDATE';

const GET_CATALOG_REMOVE_AUTONOMOUS = 'GET_CATALOG_REMOVE_AUTONOMOUS';
const SET_CATALOG_REMOVE_AUTONOMOUS = 'SET_CATALOG_REMOVE_AUTONOMOUS';

///Category
const GET_CATALOG_UPDATE_CATEGORY = 'GET_CATALOG_UPDATE_CATEGORY';
const SET_CATALOG_UPDATE_CATEGORY = 'SET_CATALOG_UPDATE_CATEGORY';

const GET_CATALOG_UPDATE_CATEGORY_SAVE = 'GET_CATALOG_UPDATE_CATEGORY_SAVE';
const SET_CATALOG_UPDATE_CATEGORY_SAVE = 'SET_CATALOG_UPDATE_CATEGORY_SAVE';

const GET_CATALOG_UPDATE_CATEGORY_VALIDATE = 'GET_CATALOG_UPDATE_CATEGORY_VALIDATE';
const SET_CATALOG_UPDATE_CATEGORY_VALIDATE = 'SET_CATALOG_UPDATE_CATEGORY_VALIDATE';

const GET_CATALOG_REMOVE_CATEGORY = 'GET_CATALOG_REMOVE_CATEGORY';
const SET_CATALOG_REMOVE_CATEGORY = 'SET_CATALOG_REMOVE_CATEGORY';

///Category Type
const GET_CATALOG_UPDATE_CATEGORY_TYPE = 'GET_CATALOG_UPDATE_CATEGORY_TYPE';
const SET_CATALOG_UPDATE_CATEGORY_TYPE = 'SET_CATALOG_UPDATE_CATEGORY_TYPE';

const GET_CATALOG_UPDATE_CATEGORY_TYPE_SAVE = 'GET_CATALOG_UPDATE_CATEGORY_TYPE_SAVE';
const SET_CATALOG_UPDATE_CATEGORY_TYPE_SAVE = 'SET_CATALOG_UPDATE_CATEGORY_TYPE_SAVE';

const GET_CATALOG_UPDATE_CATEGORY_TYPE_VALIDATE = 'GET_CATALOG_UPDATE_CATEGORY_TYPE_VALIDATE';
const SET_CATALOG_UPDATE_CATEGORY_TYPE_VALIDATE = 'SET_CATALOG_UPDATE_CATEGORY_TYPE_VALIDATE';

const GET_CATALOG_REMOVE_CATEGORY_TYPE = 'GET_CATALOG_REMOVE_CATEGORY_TYPE';
const SET_CATALOG_REMOVE_CATEGORY_TYPE = 'SET_CATALOG_REMOVE_CATEGORY_TYPE';

///Category2
const GET_CATALOG_UPDATE_CATEGORY2 = 'GET_CATALOG_UPDATE_CATEGORY2';
const SET_CATALOG_UPDATE_CATEGORY2 = 'SET_CATALOG_UPDATE_CATEGORY2';

const GET_CATALOG_UPDATE_CATEGORY2_SAVE = 'GET_CATALOG_UPDATE_CATEGORY2_SAVE';
const SET_CATALOG_UPDATE_CATEGORY2_SAVE = 'SET_CATALOG_UPDATE_CATEGORY2_SAVE';

const GET_CATALOG_UPDATE_CATEGORY2_VALIDATE = 'GET_CATALOG_UPDATE_CATEGORY2_VALIDATE';
const SET_CATALOG_UPDATE_CATEGORY2_VALIDATE = 'SET_CATALOG_UPDATE_CATEGORY2_VALIDATE';

const GET_CATALOG_REMOVE_CATEGORY2 = 'GET_CATALOG_REMOVE_CATEGORY2';
const SET_CATALOG_REMOVE_CATEGORY2 = 'SET_CATALOG_REMOVE_CATEGORY2';


///Type
const GET_CATALOG_UPDATE_TYPE = 'GET_CATALOG_UPDATE_TYPE';
const SET_CATALOG_UPDATE_TYPE = 'SET_CATALOG_UPDATE_TYPE';

const GET_CATALOG_UPDATE_TYPE_SAVE = 'GET_CATALOG_UPDATE_TYPE_SAVE';
const SET_CATALOG_UPDATE_TYPE_SAVE = 'SET_CATALOG_UPDATE_TYPE_SAVE';

const GET_CATALOG_UPDATE_TYPE_VALIDATE = 'GET_CATALOG_UPDATE_TYPE_VALIDATE';
const SET_CATALOG_UPDATE_TYPE_VALIDATE = 'SET_CATALOG_UPDATE_TYPE_VALIDATE';

const GET_CATALOG_REMOVE_TYPE = 'GET_CATALOG_REMOVE_TYPE';
const SET_CATALOG_REMOVE_TYPE = 'SET_CATALOG_REMOVE_TYPE';

//Tags
const GET_TAGS_LIST = "GET_TAGS_LIST"
const SET_TAGS_LIST = "SET_TAGS_LIST"

const SAVE_TAGS_OPTION = "SAVE_TAGS_OPTION"
const IS_TAGS_OPTION_SAVED = "IS_TAGS_OPTION_SAVED"

const VALIDATE_TAGS_OPTION = "VALIDATE_TAGS_OPTION"
const IS_TAGS_OPTION_VALID = "IS_TAGS_OPTION_VALID"

const DELETE_TAGS_OPTION = "DELETE_TAGS_OPTION"
const IS_TAGS_OPTION_DELETED = "IS_TAGS_OPTION_DELETED"

//Capacity edit 
const GET_EDIT_CATALOG_VEHICLE_CAPACITY = "GET_EDIT_CATALOG_VEHICLE_CAPACITY"
const SET_EDIT_CATALOG_VEHICLE_CAPACITY = "SET_EDIT_CATALOG_VEHICLE_CAPACITY"

///Vehicle Class
const GET_CATALOG_UPDATE_VEHICLE_CLASS = 'GET_CATALOG_UPDATE_VEHICLE_CLASS';
const SET_CATALOG_UPDATE_VEHICLE_CLASS = 'SET_CATALOG_UPDATE_VEHICLE_CLASS';

const GET_CATALOG_UPDATE_VEHICLE_CLASS_SAVE = 'GET_CATALOG_UPDATE_VEHICLE_CLASS_SAVE';
const SET_CATALOG_UPDATE_VEHICLE_CLASS_SAVE = 'SET_CATALOG_UPDATE_VEHICLE_CLASS_SAVE';

const GET_CATALOG_UPDATE_VEHICLE_CLASS_VALIDATE = 'GET_CATALOG_UPDATE_VEHICLE_CLASS_VALIDATE';
const SET_CATALOG_UPDATE_VEHICLE_CLASS_VALIDATE = 'SET_CATALOG_UPDATE_VEHICLE_CLASS_VALIDATE';

const GET_CATALOG_REMOVE_VEHICLE_CLASS = 'GET_CATALOG_REMOVE_VEHICLE_CLASS';
const SET_CATALOG_REMOVE_VEHICLE_CLASS = 'SET_CATALOG_REMOVE_VEHICLE_CLASS';

///Group Type
const GET_CATALOG_UPDATE_GROUP_TYPE = 'GET_CATALOG_UPDATE_GROUP_TYPE';
const SET_CATALOG_UPDATE_GROUP_TYPE = 'SET_CATALOG_UPDATE_GROUP_TYPE';

const GET_CATALOG_UPDATE_GROUP_TYPE_SAVE = 'GET_CATALOG_UPDATE_GROUP_TYPE_SAVE';
const SET_CATALOG_UPDATE_GROUP_TYPE_SAVE = 'SET_CATALOG_UPDATE_GROUP_TYPE_SAVE';

const GET_CATALOG_UPDATE_GROUP_TYPE_VALIDATE = 'GET_CATALOG_UPDATE_GROUP_TYPE_VALIDATE';
const SET_CATALOG_UPDATE_GROUP_TYPE_VALIDATE = 'SET_CATALOG_UPDATE_GROUP_TYPE_VALIDATE';

const GET_CATALOG_REMOVE_GROUP_TYPE = 'GET_CATALOG_REMOVE_GROUP_TYPE';
const SET_CATALOG_REMOVE_GROUP_TYPE = 'SET_CATALOG_REMOVE_GROUP_TYPE';

///Class Type
const GET_CATALOG_UPDATE_CLASS_TYPE = 'GET_CATALOG_UPDATE_CLASS_TYPE';
const SET_CATALOG_UPDATE_CLASS_TYPE = 'SET_CATALOG_UPDATE_CLASS_TYPE';

const GET_CATALOG_UPDATE_CLASS_TYPE_SAVE = 'GET_CATALOG_UPDATE_CLASS_TYPE_SAVE';
const SET_CATALOG_UPDATE_CLASS_TYPE_SAVE = 'SET_CATALOG_UPDATE_CLASS_TYPE_SAVE';

const GET_CATALOG_UPDATE_CLASS_TYPE_VALIDATE = 'GET_CATALOG_UPDATE_CLASS_TYPE_VALIDATE';
const SET_CATALOG_UPDATE_CLASS_TYPE_VALIDATE = 'SET_CATALOG_UPDATE_CLASS_TYPE_VALIDATE';

const GET_CATALOG_REMOVE_CLASS_TYPE = 'GET_CATALOG_REMOVE_CLASS_TYPE';
const SET_CATALOG_REMOVE_CLASS_TYPE = 'SET_CATALOG_REMOVE_CLASS_TYPE';

///Gross Weight
const GET_CATALOG_UPDATE_GROSS_WEIGHT = 'GET_CATALOG_UPDATE_GROSS_WEIGHT';
const SET_CATALOG_UPDATE_GROSS_WEIGHT = 'SET_CATALOG_UPDATE_GROSS_WEIGHT';

const GET_CATALOG_UPDATE_GROSS_WEIGHT_SAVE = 'GET_CATALOG_UPDATE_GROSS_WEIGHT_SAVE';
const SET_CATALOG_UPDATE_GROSS_WEIGHT_SAVE = 'SET_CATALOG_UPDATE_GROSS_WEIGHT_SAVE';

const GET_CATALOG_UPDATE_GROSS_WEIGHT_VALIDATE = 'GET_CATALOG_UPDATE_GROSS_WEIGHT_VALIDATE';
const SET_CATALOG_UPDATE_GROSS_WEIGHT_VALIDATE = 'SET_CATALOG_UPDATE_GROSS_WEIGHT_VALIDATE';

const GET_CATALOG_REMOVE_GROSS_WEIGHT = 'GET_CATALOG_REMOVE_GROSS_WEIGHT';
const SET_CATALOG_REMOVE_GROSS_WEIGHT = 'SET_CATALOG_REMOVE_GROSS_WEIGHT';

///Trim
const GET_CATALOG_UPDATE_TRIM = 'GET_CATALOG_UPDATE_TRIM';
const SET_CATALOG_UPDATE_TRIM = 'SET_CATALOG_UPDATE_TRIM';

const GET_CATALOG_UPDATE_TRIM_SAVE = 'GET_CATALOG_UPDATE_TRIM_SAVE';
const SET_CATALOG_UPDATE_TRIM_SAVE = 'SET_CATALOG_UPDATE_TRIM_SAVE';

const GET_CATALOG_UPDATE_TRIM_VALIDATE = 'GET_CATALOG_UPDATE_TRIM_VALIDATE';
const SET_CATALOG_UPDATE_TRIM_VALIDATE = 'SET_CATALOG_UPDATE_TRIM_VALIDATE';

const GET_CATALOG_REMOVE_TRIM = 'GET_CATALOG_REMOVE_TRIM';
const SET_CATALOG_REMOVE_TRIM = 'SET_CATALOG_REMOVE_TRIM';

export {
    ///No.Of.doors
    GET_CATALOG_UPDATE_NO_OF_DOORS,
    SET_CATALOG_UPDATE_NO_OF_DOORS,
    GET_CATALOG_UPDATE_NO_OF_DOORS_SAVE,
    SET_CATALOG_UPDATE_NO_OF_DOORS_SAVE,
    GET_CATALOG_UPDATE_NO_OF_DOORS_VALIDATE,
    SET_CATALOG_UPDATE_NO_OF_DOORS_VALIDATE,
    GET_CATALOG_REMOVE_NO_OF_DOORS,
    SET_CATALOG_REMOVE_NO_OF_DOORS,

    ///Year
    GET_CATALOG_UPDATE_YEAR,
    SET_CATALOG_UPDATE_YEAR,
    GET_CATALOG_UPDATE_YEAR_SAVE,
    SET_CATALOG_UPDATE_YEAR_SAVE,
    GET_CATALOG_UPDATE_YEAR_VALIDATE,
    SET_CATALOG_UPDATE_YEAR_VALIDATE,
    GET_CATALOG_REMOVE_YEAR,
    SET_CATALOG_REMOVE_YEAR,

    ///capacity
    GET_CATALOG_UPDATE_CAPACITY,
    SET_CATALOG_UPDATE_CAPACITY,
    GET_CATALOG_UPDATE_CAPACITY_SAVE,
    SET_CATALOG_UPDATE_CAPACITY_SAVE,
    GET_CATALOG_UPDATE_CAPACITY_VALIDATE,
    SET_CATALOG_UPDATE_CAPACITY_VALIDATE,
    GET_CATALOG_REMOVE_CAPACITY,
    SET_CATALOG_REMOVE_CAPACITY,

    ///UPfit
    GET_CATALOG_UPDATE_UPFIT,
    SET_CATALOG_UPDATE_UPFIT,
    GET_CATALOG_UPDATE_UPFIT_SAVE,
    SET_CATALOG_UPDATE_UPFIT_SAVE,
    GET_CATALOG_UPDATE_UPFIT_VALIDATE,
    SET_CATALOG_UPDATE_UPFIT_VALIDATE,
    GET_CATALOG_REMOVE_UPFIT,
    SET_CATALOG_REMOVE_UPFIT,

    ///Drive Train
    GET_CATALOG_UPDATE_DRIVE_TRAIN,
    SET_CATALOG_UPDATE_DRIVE_TRAIN,
    GET_CATALOG_UPDATE_DRIVE_TRAIN_SAVE,
    SET_CATALOG_UPDATE_DRIVE_TRAIN_SAVE,
    GET_CATALOG_UPDATE_DRIVE_TRAIN_VALIDATE,
    SET_CATALOG_UPDATE_DRIVE_TRAIN_VALIDATE,
    GET_CATALOG_REMOVE_DRIVE_TRAIN,
    SET_CATALOG_REMOVE_DRIVE_TRAIN,

    ///Power type
    GET_CATALOG_UPDATE_POWER_TYPE,
    SET_CATALOG_UPDATE_POWER_TYPE,
    GET_CATALOG_UPDATE_POWER_TYPE_SAVE,
    SET_CATALOG_UPDATE_POWER_TYPE_SAVE,
    GET_CATALOG_UPDATE_POWER_TYPE_VALIDATE,
    SET_CATALOG_UPDATE_POWER_TYPE_VALIDATE,
    GET_CATALOG_REMOVE_POWER_TYPE,
    SET_CATALOG_REMOVE_POWER_TYPE,

    ///Power type
    GET_CATALOG_UPDATE_VEHICLE_LEVEL,
    SET_CATALOG_UPDATE_VEHICLE_LEVEL,
    GET_CATALOG_UPDATE_VEHICLE_LEVEL_SAVE,
    SET_CATALOG_UPDATE_VEHICLE_LEVEL_SAVE,
    GET_CATALOG_UPDATE_VEHICLE_LEVEL_VALIDATE,
    SET_CATALOG_UPDATE_VEHICLE_LEVEL_VALIDATE,
    GET_CATALOG_REMOVE_VEHICLE_LEVEL,
    SET_CATALOG_REMOVE_VEHICLE_LEVEL,

    ///EQ Class code
    GET_CATALOG_UPDATE_EQ_CLASS_CODE,
    SET_CATALOG_UPDATE_EQ_CLASS_CODE,
    GET_CATALOG_UPDATE_EQ_CLASS_CODE_SAVE,
    SET_CATALOG_UPDATE_EQ_CLASS_CODE_SAVE,
    GET_CATALOG_UPDATE_EQ_CLASS_CODE_VALIDATE,
    SET_CATALOG_UPDATE_EQ_CLASS_CODE_VALIDATE,
    GET_CATALOG_REMOVE_EQ_CLASS_CODE,
    SET_CATALOG_REMOVE_EQ_CLASS_CODE,

    ///Make
    GET_CATALOG_UPDATE_MAKE,
    SET_CATALOG_UPDATE_MAKE,
    GET_CATALOG_UPDATE_MAKE_SAVE,
    SET_CATALOG_UPDATE_MAKE_SAVE,
    GET_CATALOG_UPDATE_MAKE_VALIDATE,
    SET_CATALOG_UPDATE_MAKE_VALIDATE,
    GET_CATALOG_REMOVE_MAKE,
    SET_CATALOG_REMOVE_MAKE,

    ///State Availability
    GET_CATALOG_UPDATE_STATE_AVAILABILITY,
    SET_CATALOG_UPDATE_STATE_AVAILABILITY,
    GET_CATALOG_UPDATE_STATE_AVAILABILITY_SAVE,
    SET_CATALOG_UPDATE_STATE_AVAILABILITY_SAVE,
    GET_CATALOG_UPDATE_STATE_AVAILABILITY_VALIDATE,
    SET_CATALOG_UPDATE_STATE_AVAILABILITY_VALIDATE,
    GET_CATALOG_REMOVE_STATE_AVAILABILITY,
    SET_CATALOG_REMOVE_STATE_AVAILABILITY,

    ///Model
    GET_CATALOG_UPDATE_MODEL_SAVE,
    SET_CATALOG_UPDATE_MODEL_SAVE,
    GET_CATALOG_UPDATE_MODEL_VALIDATE,
    SET_CATALOG_UPDATE_MODEL_VALIDATE,
    GET_CATALOG_UPDATE_MODEL,
    SET_CATALOG_UPDATE_MODEL,
    GET_CATALOG_REMOVE_MODEL,
    SET_CATALOG_REMOVE_MODEL,

    ///Budgeting Percent
    GET_BUDGETING_PERCENT_LIST,
    SET_BUDGETING_PERCENT_LIST,
    SAVE_BUDGETING_PERCENT_OPTION,
    IS_BUDGETING_PERCENT_OPTION_SAVED,
    VALIDATE_BUDGETING_PERCENT_OPTION,
    IS_BUDGETING_PERCENT_OPTION_VALID,
    DELETE_BUDGETING_PERCENT_OPTION,
    IS_BUDGETING_PERCENT_OPTION_DELETED,

    //Useful Life / Lease Terms
    GET_USEFUL_LIFE_LIST,
    SET_USEFUL_LIFE_LIST,
    SAVE_USEFUL_LIFE_OPTION,
    IS_USEFUL_LIFE_OPTION_SAVED,
    VALIDATE_USEFUL_LIFE_OPTION,
    IS_USEFUL_LIFE_OPTION_VALID,
    DELETE_USEFUL_LIFE_OPTION,
    IS_USEFUL_LIFE_OPTION_DELETED,

    ///Program status
    GET_CATALOG_UPDATE_PROGRAM_STATUS,
    SET_CATALOG_UPDATE_PROGRAM_STATUS,
    GET_CATALOG_UPDATE_PROGRAM_STATUS_SAVE,
    SET_CATALOG_UPDATE_PROGRAM_STATUS_SAVE,
    GET_CATALOG_UPDATE_PROGRAM_STATUS_VALIDATE,
    SET_CATALOG_UPDATE_PROGRAM_STATUS_VALIDATE,
    GET_CATALOG_REMOVE_PROGRAM_STATUS,
    SET_CATALOG_REMOVE_PROGRAM_STATUS,

    ///Annual Hours
    GET_CATALOG_UPDATE_ANNUAL_HOURS,
    SET_CATALOG_UPDATE_ANNUAL_HOURS,
    GET_CATALOG_UPDATE_ANNUAL_HOURS_SAVE,
    SET_CATALOG_UPDATE_ANNUAL_HOURS_SAVE,
    GET_CATALOG_UPDATE_ANNUAL_HOURS_VALIDATE,
    SET_CATALOG_UPDATE_ANNUAL_HOURS_VALIDATE,
    GET_CATALOG_REMOVE_ANNUAL_HOURS,
    SET_CATALOG_REMOVE_ANNUAL_HOURS,

    ///Deck Size
    GET_CATALOG_UPDATE_DECK_SIZE,
    SET_CATALOG_UPDATE_DECK_SIZE,
    GET_CATALOG_UPDATE_DECK_SIZE_SAVE,
    SET_CATALOG_UPDATE_DECK_SIZE_SAVE,
    GET_CATALOG_UPDATE_DECK_SIZE_VALIDATE,
    SET_CATALOG_UPDATE_DECK_SIZE_VALIDATE,
    GET_CATALOG_REMOVE_DECK_SIZE,
    SET_CATALOG_REMOVE_DECK_SIZE,

    ///Deck Type
    GET_CATALOG_UPDATE_DECK_TYPE,
    SET_CATALOG_UPDATE_DECK_TYPE,
    GET_CATALOG_UPDATE_DECK_TYPE_SAVE,
    SET_CATALOG_UPDATE_DECK_TYPE_SAVE,
    GET_CATALOG_UPDATE_DECK_TYPE_VALIDATE,
    SET_CATALOG_UPDATE_DECK_TYPE_VALIDATE,
    GET_CATALOG_REMOVE_DECK_TYPE,
    SET_CATALOG_REMOVE_DECK_TYPE,

    ///Length
    GET_CATALOG_UPDATE_LENGTH,
    SET_CATALOG_UPDATE_LENGTH,
    GET_CATALOG_UPDATE_LENGTH_SAVE,
    SET_CATALOG_UPDATE_LENGTH_SAVE,
    GET_CATALOG_UPDATE_LENGTH_VALIDATE,
    SET_CATALOG_UPDATE_LENGTH_VALIDATE,
    GET_CATALOG_REMOVE_LENGTH,
    SET_CATALOG_REMOVE_LENGTH,

    ///Size
    GET_CATALOG_UPDATE_SIZE,
    SET_CATALOG_UPDATE_SIZE,
    GET_CATALOG_UPDATE_SIZE_SAVE,
    SET_CATALOG_UPDATE_SIZE_SAVE,
    GET_CATALOG_UPDATE_SIZE_VALIDATE,
    SET_CATALOG_UPDATE_SIZE_VALIDATE,
    GET_CATALOG_REMOVE_SIZE,
    SET_CATALOG_REMOVE_SIZE,

    ///Autonomous
    GET_CATALOG_UPDATE_AUTONOMOUS,
    SET_CATALOG_UPDATE_AUTONOMOUS,
    GET_CATALOG_UPDATE_AUTONOMOUS_SAVE,
    SET_CATALOG_UPDATE_AUTONOMOUS_SAVE,
    GET_CATALOG_UPDATE_AUTONOMOUS_VALIDATE,
    SET_CATALOG_UPDATE_AUTONOMOUS_VALIDATE,
    GET_CATALOG_REMOVE_AUTONOMOUS,
    SET_CATALOG_REMOVE_AUTONOMOUS,

    ///Category
    GET_CATALOG_UPDATE_CATEGORY,
    SET_CATALOG_UPDATE_CATEGORY,
    GET_CATALOG_UPDATE_CATEGORY_SAVE,
    SET_CATALOG_UPDATE_CATEGORY_SAVE,
    GET_CATALOG_UPDATE_CATEGORY_VALIDATE,
    SET_CATALOG_UPDATE_CATEGORY_VALIDATE,
    GET_CATALOG_REMOVE_CATEGORY,
    SET_CATALOG_REMOVE_CATEGORY,

    ///Category type
    GET_CATALOG_UPDATE_CATEGORY_TYPE,
    SET_CATALOG_UPDATE_CATEGORY_TYPE,
    GET_CATALOG_UPDATE_CATEGORY_TYPE_SAVE,
    SET_CATALOG_UPDATE_CATEGORY_TYPE_SAVE,
    GET_CATALOG_UPDATE_CATEGORY_TYPE_VALIDATE,
    SET_CATALOG_UPDATE_CATEGORY_TYPE_VALIDATE,
    GET_CATALOG_REMOVE_CATEGORY_TYPE,
    SET_CATALOG_REMOVE_CATEGORY_TYPE,

    ///Category2
    GET_CATALOG_UPDATE_CATEGORY2,
    SET_CATALOG_UPDATE_CATEGORY2,
    GET_CATALOG_UPDATE_CATEGORY2_SAVE,
    SET_CATALOG_UPDATE_CATEGORY2_SAVE,
    GET_CATALOG_UPDATE_CATEGORY2_VALIDATE,
    SET_CATALOG_UPDATE_CATEGORY2_VALIDATE,
    GET_CATALOG_REMOVE_CATEGORY2,
    SET_CATALOG_REMOVE_CATEGORY2,

    //Type
    GET_CATALOG_UPDATE_TYPE,
    SET_CATALOG_UPDATE_TYPE,
    GET_CATALOG_UPDATE_TYPE_SAVE,
    SET_CATALOG_UPDATE_TYPE_SAVE,
    GET_CATALOG_UPDATE_TYPE_VALIDATE,
    SET_CATALOG_UPDATE_TYPE_VALIDATE,
    GET_CATALOG_REMOVE_TYPE,
    SET_CATALOG_REMOVE_TYPE,

    //Tags
    GET_TAGS_LIST,
    SET_TAGS_LIST,
    SAVE_TAGS_OPTION,
    IS_TAGS_OPTION_SAVED,
    VALIDATE_TAGS_OPTION,
    IS_TAGS_OPTION_VALID,
    DELETE_TAGS_OPTION,
    IS_TAGS_OPTION_DELETED,

    //Capacity edit
    GET_EDIT_CATALOG_VEHICLE_CAPACITY,
    SET_EDIT_CATALOG_VEHICLE_CAPACITY,

    ///Vehicle Class
    GET_CATALOG_UPDATE_VEHICLE_CLASS,
    SET_CATALOG_UPDATE_VEHICLE_CLASS,
    GET_CATALOG_UPDATE_VEHICLE_CLASS_SAVE,
    SET_CATALOG_UPDATE_VEHICLE_CLASS_SAVE,
    GET_CATALOG_UPDATE_VEHICLE_CLASS_VALIDATE,
    SET_CATALOG_UPDATE_VEHICLE_CLASS_VALIDATE,
    GET_CATALOG_REMOVE_VEHICLE_CLASS,
    SET_CATALOG_REMOVE_VEHICLE_CLASS,

    ///Group Type
    GET_CATALOG_UPDATE_GROUP_TYPE,
    SET_CATALOG_UPDATE_GROUP_TYPE,
    GET_CATALOG_UPDATE_GROUP_TYPE_SAVE,
    SET_CATALOG_UPDATE_GROUP_TYPE_SAVE,
    GET_CATALOG_UPDATE_GROUP_TYPE_VALIDATE,
    SET_CATALOG_UPDATE_GROUP_TYPE_VALIDATE,
    GET_CATALOG_REMOVE_GROUP_TYPE,
    SET_CATALOG_REMOVE_GROUP_TYPE,

    ///Class Type
    GET_CATALOG_UPDATE_CLASS_TYPE,
    SET_CATALOG_UPDATE_CLASS_TYPE,
    GET_CATALOG_UPDATE_CLASS_TYPE_SAVE,
    SET_CATALOG_UPDATE_CLASS_TYPE_SAVE,
    GET_CATALOG_UPDATE_CLASS_TYPE_VALIDATE,
    SET_CATALOG_UPDATE_CLASS_TYPE_VALIDATE,
    GET_CATALOG_REMOVE_CLASS_TYPE,
    SET_CATALOG_REMOVE_CLASS_TYPE,

    ///Gross Weight
    GET_CATALOG_UPDATE_GROSS_WEIGHT,
    SET_CATALOG_UPDATE_GROSS_WEIGHT,
    GET_CATALOG_UPDATE_GROSS_WEIGHT_SAVE,
    SET_CATALOG_UPDATE_GROSS_WEIGHT_SAVE,
    GET_CATALOG_UPDATE_GROSS_WEIGHT_VALIDATE,
    SET_CATALOG_UPDATE_GROSS_WEIGHT_VALIDATE,
    GET_CATALOG_REMOVE_GROSS_WEIGHT,
    SET_CATALOG_REMOVE_GROSS_WEIGHT,

    ///Gross Weight
    GET_CATALOG_UPDATE_TRIM,
    SET_CATALOG_UPDATE_TRIM,
    GET_CATALOG_UPDATE_TRIM_SAVE,
    SET_CATALOG_UPDATE_TRIM_SAVE,
    GET_CATALOG_UPDATE_TRIM_VALIDATE,
    SET_CATALOG_UPDATE_TRIM_VALIDATE,
    GET_CATALOG_REMOVE_TRIM,
    SET_CATALOG_REMOVE_TRIM,
};
